module.exports = __webpack_public_path__ + "01_long_beige.3073d5fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/01_long_beige.png
// module id = zNc4
// module chunks = 0